'use client';

import { formCheckboxField } from '@lib/form/helper';
import { CheckboxField } from '@tuic/web-compositions/core/CheckboxField';

import type { AnyFieldApi } from '@tanstack/react-form';
import type { FC, ReactNode } from 'react';

export type ManifestCheckboxFieldProps = {
  field: AnyFieldApi;
  label?: ReactNode;
  note?: ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
};

export const ManifestCheckboxField: FC<ManifestCheckboxFieldProps> = ({
  field,
  label,
  note,
  required,
  disabled,
  className,
}) => (
  <CheckboxField
    {...formCheckboxField(field)}
    name={field.name}
    label={label}
    note={note}
    required={required ? 'label' : undefined}
    disabled={disabled}
    className={className}
  />
);
